import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

/**
 * ETLUpdate component - used to show ETL last update datetime on Deallocation and Need pages.
 *
 * @param {Object} props - Props for the ETLUpdate component.
 * @param {string} props.date - The date value.
 * @returns {JSX.Element} The ETLUpdate component.
 * @example
 * 	<ETLUpdate date="2023-06-22 14:21" />
 */
function ETLUpdate({ date }) {
	const { t } = useTranslation();

	return (
		<Tooltip title={t('etlGuide')}>
			<div className='etl-container'>
				<div className='etl-container--status' />
				<span className='etl-container--text'>{t('etlUpdate')} {date.replaceAll('-', '/')} (GMT-3)</span>
			</div>
		</Tooltip>
	);
}

ETLUpdate.defaultProps = {
	date: '',
};

export default ETLUpdate;
